import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";

export function useCountdown(deadline) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const ms = deadline - now;
  if (ms <= 0) return { expired: true, label: "" };
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return {
    expired: false,
    label:
      d > 0
        ? `${d}d ${h}h ${m}m ${s}s`
        : h > 0
        ? `${h}h ${m}m ${s}s`
        : m > 0
        ? `${m}m ${s}s`
        : `${s}s`,
  };
}

export function DateHoldBanner({ deadline }) {
  const { expired, label } = useCountdown(deadline);
  if (expired) return null;
  return (
    <div
      data-testid="date-hold-banner"
      className="sticky top-0 z-40 bg-[#21201F] text-white px-4 py-2.5 text-center border-b border-white/10"
    >
      <span className="text-[11px] md:text-xs tracking-[0.15em] uppercase font-medium text-white/90">
        We're holding your date. This quote is valid until{" "}
        {new Date(deadline).toLocaleDateString("en-GB", {
          weekday: "long",
          day: "numeric",
          month: "long",
        })}
      </span>
      <span className="ml-3 inline-flex items-center gap-1.5 bg-[#CCBA56] text-[#1F1E1D] rounded-full px-3 py-0.5 text-[11px] font-medium tabular-nums align-middle">
        {label} left
      </span>
    </div>
  );
}

export function CountdownChip({ deadline, testId }) {
  const { expired, label } = useCountdown(deadline);
  if (expired) return null;
  return (
    <div
      data-testid={testId}
      className="inline-flex items-center gap-2 bg-[#CCBA56] text-[#1F1E1D] rounded-full px-5 py-2 text-sm font-medium tabular-nums mb-10"
    >
      Offer ends in {label}
    </div>
  );
}

export function DateSecuredBanner() {
  return (
    <div
      data-testid="date-secured-banner"
      className="sticky top-0 z-40 bg-[#21201F] text-white px-4 py-2.5 text-center border-b border-white/10"
    >
      <span className="inline-flex items-center gap-2 text-[11px] md:text-xs tracking-[0.15em] uppercase font-medium text-white/90">
        <CheckCircle2 className="w-4 h-4 text-[#CCBA56]" strokeWidth={2} />
        Your date is secured. We can't wait to celebrate with you!
      </span>
    </div>
  );
}
